import { Tooltip } from 'react-tooltip';
import Router from './Router';
import ToastContainer from './components/ToastContainer';

function App() {
  return (
    <>
      <ToastContainer />
      <Router />
      <Tooltip
        id={'global-tooltip'}
        style={{ backgroundColor: 'black', color: 'white', zIndex: 99999 }}
        place="bottom"
      />
    </>
  );
}

export default App;
